import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { LinkContainer } from 'react-router-bootstrap';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import classNames from 'classnames';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import {
    Update, Done, SpeakerNotes, People,
    SupervisedUserCircle, Description, Folder
} from '@material-ui/icons';
import i18n from "i18next";

const drawerWidth = '100%';

const styles = theme => ({
    root: {
        display: 'flex',
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    appBarSpacer: theme.mixins.toolbar,
});

class Submenu extends Component {
    state = {
        open: true,
    };

    // Define static submenu items (translated dynamically)
    getMenuItems = () => [
        { titleKey: 'history', icon: 'Update', articleId: 5 },
        { titleKey: 'mission', icon: 'Done', articleId: 226 },
        { titleKey: 'activities', icon: 'SpeakerNotes', articleId: 227 },
        { titleKey: 'team', icon: 'People', articleId: 230 },
        { titleKey: 'references', icon: 'Description', articleId: 19 },
        { titleKey: 'partners', icon: 'SupervisedUserCircle', articleId: 47 },
        { titleKey: 'projects', icon: 'Folder', articleId: 229 },
        
    ];

    render() {
        const { classes } = this.props;

        const icons = {
            'Update': <Update />,
            'Done': <Done />,
            'SpeakerNotes': <SpeakerNotes />,
            'People': <People />,
            'SupervisedUserCircle': <SupervisedUserCircle />,
            'Description': <Description />,
            'Folder': <Folder />,
        };

        const menuItems = this.getMenuItems();

        return (
            <div>
                <Drawer
                    variant="permanent"
                    classes={{
                        paper: classNames(classes.drawerPaper),
                    }}
                    open={this.state.open}
                >
                    <Divider />
                    {menuItems.map((el, idx) => (
                        <LinkContainer to={`/article/${el.articleId}`} key={idx}>
                            <ListItem button>
                                <ListItemIcon>
                                    {icons[el.icon]}
                                </ListItemIcon>
                                <ListItemText primary={i18n.t(el.titleKey)} />
                            </ListItem>
                        </LinkContainer>
                    ))}
                    <Divider />
                </Drawer>
            </div>
        );
    }
}

export default withStyles(styles)(Submenu);



//import React, { Component } from 'react';
//import { withStyles } from '@material-ui/core/styles';
//import { LinkContainer } from 'react-router-bootstrap';
//import ListItem from '@material-ui/core/ListItem';
//import ListItemIcon from '@material-ui/core/ListItemIcon';
//import ListItemText from '@material-ui/core/ListItemText';
//import Drawer from '@material-ui/core/Drawer';
//import Divider from '@material-ui/core/Divider';
//import classNames from 'classnames';
//import {
//    Update,
//    Done,
//    SpeakerNotes,
//    People,
//    SupervisedUserCircle,
//    Description,
//    Folder
//} from '@material-ui/icons';
//import i18n from "i18next";

//const drawerWidth = '100%';

//const styles = theme => ({
//    root: {
//        display: 'flex',
//    },
//    drawerPaper: {
//        position: 'relative',
//        whiteSpace: 'nowrap',
//        width: drawerWidth,
//        transition: theme.transitions.create('width', {
//            easing: theme.transitions.easing.sharp,
//            duration: theme.transitions.duration.enteringScreen,
//        }),
//    },
//    appBarSpacer: theme.mixins.toolbar,
//    content: {
//        flexGrow: 1,
//        height: '100vh',
//        overflow: 'auto',
//    },
//});

//class Submenu extends Component {
//    state = {
//        open: true,
//    };

//    // Static menu definitions for both languages
//    getStaticMenuItems = () => {
//        const lang = i18n.language || "bg";

//        const menus = {
//            bg: [
//                { title: "За нас", link: "/about", icon: "People" },
//                { title: "Екип", link: "/team", icon: "SupervisedUserCircle" },
//                { title: "Новини", link: "/news", icon: "SpeakerNotes" },
//                { title: "Документи", link: "/documents", icon: "Description" },
//                { title: "Папка", link: "/files", icon: "Folder" },
//                { title: "Актуализации", link: "/updates", icon: "Update" },
//                { title: "Изпълнени", link: "/completed", icon: "Done" },
//            ],
//            en: [
//                { title: "About Us", link: "/about", icon: "People" },
//                { title: "Team", link: "/team", icon: "SupervisedUserCircle" },
//                { title: "News", link: "/news", icon: "SpeakerNotes" },
//                { title: "Documents", link: "/documents", icon: "Description" },
//                { title: "Files", link: "/files", icon: "Folder" },
//                { title: "Updates", link: "/updates", icon: "Update" },
//                { title: "Completed", link: "/completed", icon: "Done" },
//            ]
//        };

//        return menus[lang] || menus.bg;
//    };

//    componentDidMount() {
//        // Force re-render when language changes
//        this.languageChangeHandler = () => this.forceUpdate();
//        i18n.on("languageChanged", this.languageChangeHandler);
//    }

//    componentWillUnmount() {
//        if (this.languageChangeHandler) {
//            i18n.off("languageChanged", this.languageChangeHandler);
//        }
//    }

//    render() {
//        const { classes } = this.props;
//        const icons = {
//            Update: <Update />,
//            Done: <Done />,
//            SpeakerNotes: <SpeakerNotes />,
//            People: <People />,
//            SupervisedUserCircle: <SupervisedUserCircle />,
//            Description: <Description />,
//            Folder: <Folder />,
//        };

//        const elements = this.getStaticMenuItems();

//        return (
//            <div>
//                <Drawer
//                    variant="permanent"
//                    classes={{
//                        paper: classNames(classes.drawerPaper),
//                    }}
//                    open={this.state.open}
//                >
//                    <Divider />
//                    {elements.map((el, index) => (
//                        <LinkContainer key={index} to={el.link}>
//                            <ListItem button>
//                                <ListItemIcon>
//                                    {icons[el.icon]}
//                                </ListItemIcon>
//                                <ListItemText primary={el.title} />
//                            </ListItem>
//                        </LinkContainer>
//                    ))}
//                    <Divider />
//                </Drawer>
//            </div>
//        );
//    }
//}

//export default withStyles(styles)(Submenu);



//import React, { Component } from 'react';
//import { withStyles } from '@material-ui/core/styles';
//import Typography from '@material-ui/core/Typography';
//import { LinkContainer } from 'react-router-bootstrap';
//import ListItem from '@material-ui/core/ListItem';
//import ListItemIcon from '@material-ui/core/ListItemIcon';
//import ListItemText from '@material-ui/core/ListItemText';
//import classNames from 'classnames';
//import Drawer from '@material-ui/core/Drawer';
//import Divider from '@material-ui/core/Divider';
//import IconButton from '@material-ui/core/IconButton';
//import { Update, Done, SpeakerNotes, People, SupervisedUserCircle, Description, Folder, ChevronLeft, ChevronRight } from '@material-ui/icons';
//import i18n from "i18next";

//const drawerWidth = '100%';

//const styles = theme => ({
//    root: {
//        display: 'flex',
//    },
//    toolbar: {
//        paddingRight: 24,
//    },
//    toolbarIcon: {
//        display: 'flex',
//        alignItems: 'center',
//        justifyContent: 'flex-end',
//        padding: '0 8px',
//        ...theme.mixins.toolbar,
//    },
//    appBar: {
//        zIndex: theme.zIndex.drawer ,
//        transition: theme.transitions.create(['width', 'margin'], {
//            easing: theme.transitions.easing.sharp,
//            duration: theme.transitions.duration.leavingScreen,
//        }),
//    },
//    appBarShift: {
//        width: `calc(100% - ${drawerWidth}px)`,
//        transition: theme.transitions.create(['width', 'margin'], {
//            easing: theme.transitions.easing.sharp,
//            duration: theme.transitions.duration.enteringScreen,
//        }),
//    },

//    menuButtonHidden: {
//        display: 'none',
//    },
//    title: {
//        flexGrow: 1,
//    },
//    drawerPaper: {
//        position: 'relative',
//        whiteSpace: 'nowrap',
//        width: drawerWidth,
//        transition: theme.transitions.create('width', {
//            easing: theme.transitions.easing.sharp,
//            duration: theme.transitions.duration.enteringScreen,
//        }),
//    },
//    drawerPaperClose: {
//        overflowX: 'hidden',
//        transition: theme.transitions.create('width', {
//            easing: theme.transitions.easing.sharp,
//            duration: theme.transitions.duration.leavingScreen,
//        }),
//        width: theme.spacing.unit,
//        [theme.breakpoints.up('sm')]: {
//            width: theme.spacing.unit * 9,
//        },
//    },
//    appBarSpacer: theme.mixins.toolbar,
//    content: {
//        flexGrow: 1,
//        height: '100vh',
//        overflow: 'auto',
//    },

//});

//class Submenu extends Component {
//    state = {
//        open: true,
//    };

//    componentWillMount() {

//    }

//    componentDidMount() {
//        const { articleId, requestSubmenuElements } = this.props;

//        // Initial fetch if needed
//        if (articleId) {
//            requestSubmenuElements(articleId);
//        }

//        // Re-fetch on language change
//        i18n.on("languageChanged", (lang) => {
//            if (articleId) {
//                requestSubmenuElements(articleId);
//            }
//        });
//    }

//    componentWillUnmount() {
//        i18n.off("languageChanged");
//    }


//    render() {
//        const props = this.props;
//        const { classes } = this.props;
        
//        const icons = {
//            'Update': <Update />,
//            'Done': <Done />,
//            'SpeakerNotes': <SpeakerNotes />,
//            'People': <People />,
//            'SupervisedUserCircle': <SupervisedUserCircle/>,
//            'Description': <Description />,
//            'Folder': <Folder />,
//        };

//        return (
//            <div>
//                <Drawer
//                    variant="permanent"
//                    classes={{
//                        paper: classNames(classes.drawerPaper),
//                    }}
//                    open={this.state.open}
//                >
//                    <Divider />

//                    {props.elements.map((el) =>
//                        <LinkContainer to={el.articleId != null ? `/article/${el.articleId}` : el.link}>
//                            <ListItem button>
//                                <ListItemIcon>
//                                    {icons[el.icon]}                                    
//                                </ListItemIcon>
//                                <ListItemText primary={el.title} />
//                            </ListItem>
//                        </LinkContainer>
//                    )}
//                    <Divider />
//                </Drawer>
//            </div>
//        );
//    }
//}

//function Module(icons, i) {
//    let Module = icons[i];
//    return <Module key={i} />
//}

//export default withStyles(styles)(Submenu);